/* eslint-disable */
export default {
  loginButton: 'Fazer login',
  signupButton: 'Novo usuário? Inscreva-se',
  version: 'Versão',
} as const;

// @key: @#@"loginButton"@#@ @source: @#@"Sign In"@#@
// @key: @#@"signupButton"@#@ @source: @#@"New user? Sign Up"@#@
// @key: @#@"version"@#@ @source: @#@"Version"@#@
